import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type fetchBehavioralObservationModel = {
  id: string | number
}

export const fetchBehavioralObservation = ({
  id
}: fetchBehavioralObservationModel) => {
  return new ServicesUseCase(
    `/observacaoComportamental/load/${id}`,
    makeAxiosHttpClient()
  )
}

export const updateBehavioralObservation = ({
  id
}: fetchBehavioralObservationModel) => {
  return new ServicesUseCase(
    `/observacaoComportamental/update/${id}`,
    makeAxiosHttpClient()
  )
}
